<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-33 md-small-size-100 tagline">
      <h2><b>HomeGaroo</b></h2>
      <h3>
        <b>
          <span class="material-icons">
            engineering
          </span>
          Unfortunately, we are still under development and don't offer any
          services yet. Check us again soon!
        </b>
      </h3>
      <h4>
        <b>
          Need to contact us? Email us at j.peshev@homegaroo.nl or
          m.garkov@homegaroo.nl.
        </b>
      </h4>

      <!-- <h2><b>HomeGaroo</b></h2>
            <h3>
            <b>
                Fast. Convenient. Reliable.
            </b>
            </h3>
            <h4>
            <b>
                Everything you or your home might need in one single platform:
                cooking, construction, dog walking, cleaning, locksmith and so
                much more. Now made easy, join us and find for yourslelf.
            </b>
            </h4> -->
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  }
};
</script>

<style></style>
